<template>
  <div
    :class="[
      'tw-w-full tw-flex tw-flex-col tw-relative tw-h-full',
      'tw-overflow-auto scrollbar-hide',
    ]"
  >
    <div
      :class="[
        'tw-text-h3-bold-mobile apTablet2:tw-text-h3-bold-desktop',
        'tw-mt-8 tw-mb-[64px]',
      // 'dark:tw-text-white'
      ]"
    >Select the project component that apply</div>
    <div class="tw-pb-6 tw-text-body-bold-mobile apTablet2:tw-text-body-bold-desktop">
      Please select all that apply:
    </div>
    <div class="tw-grid tw-grid-cols-1 apDesktop:tw-grid-cols-2 tw-gap-4 tw-pb-4">
      <SelectForm
        v-for="option in options"
        :key="option"
        :value="option"
        :selected="selectedOption.includes(option)"
        @click="onSelectItem(option)"
      />
      <TextForm v-model:data="otherOption" :placeholder="'Others (please specify)'" />
    </div>
    <div class="apDesktop:tw-mb-[64px] tw-mb-[78px] tw-mt-[76px]">
      <NextButton label="Next" :enable="allowNextButton" @click="onClickNext" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import { ContactUs } from '../../model/interfaces/ContactUs';
import SelectForm from '../shared/SelectForm.vue';
import TextForm from '../shared/TextForm.vue';
import NextButton from './NextButton.vue';

const props = defineProps < {
  contactUs: ContactUs
} > ();

const selectedOption = ref<Array<string>>([]);
const otherOption = ref('');

const options = ref([
  'Website',
  'Mobile app, web app, PWA',
  'Content management system (CMS)',
  'Admin dashboard',
  'Server-side processing (e.g. Node.js, PHP)',
  'Cloud infrastructure (e.g. AWS, Azure)',
  'Exploring options/Open to suggestions',
]);

const emit = defineEmits(['clickNext']);

function onClickNext() {
  if (otherOption.value !== '') {
    selectedOption.value.push(otherOption.value);
  }
  props.contactUs.project_types = selectedOption.value;
  emit('clickNext');
}

function onSelectItem(item: string) {
  if (selectedOption.value.includes(item)) {
    selectedOption.value = selectedOption.value.filter((option) => option !== item);
  } else {
    selectedOption.value.push(item);
  }
}

const allowNextButton = computed(() => {
  return selectedOption.value.length > 0 || otherOption.value !== '';
});

onMounted(() => {
  if (props.contactUs.project_types.length > 0) {
    selectedOption.value = props.contactUs.project_types;
    selectedOption.value.forEach((option) => {
      if (!options.value.includes(option)) {
        otherOption.value = option;
        //remove that option from selectedOption
        selectedOption.value = selectedOption.value.filter((item) => item !== option);
      }
    });
  }
});

</script>

<style scoped>
.scrollbar-hide::-webkit-scrollbar {
    display: none;
}

/* For IE, Edge and Firefox */
.scrollbar-hide {
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
}
</style>